<template>
  <div
  class="map-home-component"
  v-bind:class="{isDarkMode: isDarkMode}">
    <div ref="mapdiv" id="outage-map" class="outage-map-home"></div>
    <div class="map-filters"></div>
    <map-info-icon :isDarkMode="isDarkMode" :iconClick="mapInfoIconClick"></map-info-icon>
  </div>
</template>

<script>
import Map from "@/services/map";
import vueMqMixin from "../mixins/VueMqMixin";
import AppConfig from "../../../resources/AppConfig.js";
import MapInfoIcon from "./MapInfoIcon";

const DRAW_MAP_DELAY = 300;

export default {
  mixins: [vueMqMixin],
  components: {
      MapInfoIcon
  },
  props: {
    zoomLevel: Number,
    isDarkMode: Boolean,
    drawerOpen: Boolean,
    mapView: String,
    townOutages: Array,
    countyOutages: Array,
    utilityOutages: Array,
    mapInfoIconClick: Function
  },
  data() {
    return {
      map: undefined,
      isDesktopView: undefined,
      mapControlsRight: ''
    };
  },
  mounted() {
    this.setMapControlsRight();
  },
  async created() {
    this.isDesktopView = !this.isMobile() && !this.isTablet();
    setTimeout(this.CreateMap, DRAW_MAP_DELAY);
  },
  watch: {
    mapView: function () {
      this.switchMapLayer();
    },
    drawerOpen: function () {
      if (!this.isDesktopView){return; }

      if (this.drawerOpen) {
        this.map.drawerOpen = true;
        this.map.centerMapRelativetoDrawer();
      } else {
        this.map.drawerOpen = false;
        this.map.centerMapRelativetoViewport();
      }
    },
    isDarkMode: function (isDarkMode) {
      if (isDarkMode) {
        this.map.setDarkMode();
      } else {
        this.map.removeDarkMode();
      }
      setTimeout(this.switchMapLayer, 1000);
    },
    utilityOutages: function () {
      this.map.utilityOutages = this.utilityOutages;
      setTimeout(this.switchMapLayer, DRAW_MAP_DELAY);
    },
    countyOutages: function () {
      this.map.countyOutages = this.countyOutages;
      setTimeout(this.switchMapLayer, DRAW_MAP_DELAY);
    },
    townOutages: function () {
      this.map.townOutages = this.townOutages;
      setTimeout(this.switchMapLayer, DRAW_MAP_DELAY);
    },
  },
  methods: {
    switchMapLayer() {
      switch(this.mapView) {
        case 'county':
        this.showCountiesLayer();
        break;
        case 'town':
        this.showTownsLayer();
        break;
        case 'utility':
        this.showUtilitiesLayer();
        break;
      }
    },
    showTownsLayer() {
      this.map.showTownsLayer();
    },
    showCountiesLayer() {
      this.map.showCountiesLayer();
    },
    showUtilitiesLayer() {
      this.map.showUtilitiesLayer();
    },
    setMapControlsRight() {

      switch(AppConfig.simpleDrawerWidth) {
        case 'small':
          this.mapControlsRight = '425px';
        break;
        case 'medium':
          this.mapControlsRight = '530px';
        break;
        case 'large':
          this.mapControlsRight = '665px';
        break;
      }
    },
    styleMapControls() {
      const $mapContainer = document.querySelector('#outage-map .mapboxgl-control-container');
      const $ctrlTopRight = $mapContainer.querySelector('.mapboxgl-ctrl-top-right');
      const $ctrlBottomRight = $mapContainer.querySelector('.mapboxgl-ctrl-bottom-right');

      $ctrlTopRight.style.right = this.mapControlsRight;
      $ctrlTopRight.style.display = 'block';
      $ctrlBottomRight.style.right = this.mapControlsRight;
      $ctrlBottomRight.style.display = 'block';
    },
    determineMapView() {
      switch(this.mapView) {
        case 'county':
         this.showCountiesLayer();
        break;
        case 'town':
          this.showTownsLayer();
        break;
        case 'utility':
          this.showUtilitiesLayer();
        break;
      }
    },
    async CreateMap() {
      try {
        this.map = new Map(this.townOutages, this.countyOutages, this.utilityOutages);
        this.map.isDesktop = this.isDesktopView;
        await this.map.CreateOutageMap(this.isDarkMode, this.$refs.mapdiv);
        this.map.uiUpdatecallback = () => {this.$forceUpdate()};
        setTimeout(this.determineMapView, 200);
        setTimeout(this.styleMapControls, 50);
      } catch (err) {
        console.log("Unable to create map");
        console.log(err);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.map-home-component{
  position: relative;
}
</style>
